<template>
    <v-row>
        <v-col>
            <v-card class="pa-4">
                <v-card-title>{{ collection.title }}</v-card-title>
                <v-card-text>
                    <CollectionTabLinks />
                    <v-row>
                        <v-col>
                            <v-btn
                                color="primary"
                                class="mr-3"
                                @click="openSiteList"
                            >Добавить сайт</v-btn>
                            <!-- <Draggable v-model="collectionSites" tag="tr">
                                <div v-for="item in collectionSites" class="" :key="item.id">
                                    <div>{{ item.title }}</div>
                                    <div align="right">
                                        <v-icon color="error" @click="removeSite(item)">mdi-trash-can</v-icon>
                                    </div>
                                </div>
                            </Draggable> -->
                            <v-simple-table>
                                <template v-slot:default>
                                    <Draggable v-model="collection.addedSites" tag="tbody">
                                        <tr v-for="item in collection.addedSites" :key="item.id">
                                            <td>{{ item.title }}</td>
                                            <td align="right">
                                                <v-icon color="error" @click="removeSite(item)">mdi-trash-can</v-icon>
                                            </td>
                                        </tr>
                                    </Draggable>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pa-4 d-flex justify-space-between">
                    <div>
                        <v-btn
                            color="primary"
                            class="mr-3"
                            @click="save"
                        >Сохранить</v-btn>
                        <v-btn
                            color="light"
                            class="mr-3"
                            @click="goBack"
                        >Отмена</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-dialog
            v-model="siteListModal"
            width="800px"
        >
            <v-card>
                <v-card-title class="primary">
                    Выберите блюдо
                </v-card-title>

                <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr v-for="item in checkedSites" :key="item.id">
                                    <td>{{ item.title }}</td>
                                    <td align="right">
                                        <v-icon v-if="item.added" color="error" @click="removeSite(item)">mdi-trash-can</v-icon>
                                        <v-icon v-else color="primary" @click="addSite(item)">mdi-plus</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="light"
                        @click="siteListModal = false"
                    >Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import store from '../../store';
    import Draggable from 'vuedraggable';
    import { mapState } from 'vuex';
    import CollectionTabLinks from '../../components/collections/CollectionTabLinks';

    export default {
        name: 'CollectionSites',

        components: {
            CollectionTabLinks,
            Draggable
        },

        data() {
            return {
                loading: true,
                collection: {},
                siteListModal: false,
            };
        },

        computed: {
            ...mapState('auth', ['user']),
            ...mapState('collections', {
                oldCollection: state => state.entity
            }),
            ...mapState('sites', {
                sites: state => state.entities
            }),
            addedSiteIds() {
                return this.collection.addedSites.map(item => item.id);
            },
            checkedSites() {
                return this.sites.map(site => {
                    const finded = this.collection.addedSites.find(item => item.id === site.id)
                    return {
                        ...site,
                        added: finded && finded.id,
                        collection_site_id: finded ? finded.collection_site_id : null
                    }
                }).sort((a, b) => a.title < b.title ? -1 : 1);
            },
            collectionSites() {
                return this.collection.addedSites;
            },
            isAdmin() {
                return this.user.admin;
            }
        },

        async mounted() {
            this.loading = true;
            const id = this.$route.params.id;
            if(id) {
                await store.dispatch('sites/fetch', {});
                if(id) {
                    await this.get(id);
                }
            }
            this.loading = false;
        },

        methods: {
            async openSiteList() {
                this.siteListModal = true;
            },
            async addSite(site) {
                this.collection.addedSites.push(site);
            },
            async removeSite(site) {
                this.collection.addedSites = this.collection.addedSites.filter(item => item.id !== site.id);
                if(site.collection_site_id) {
                    this.collection.removedSites.push(site);
                }
            },
            async get(id) {
                await store.dispatch('collections/get', {id});
                this.collection = {
                    ...this.oldCollection,
                    addedSites: this.oldCollection.sites,
                    removedSites: [],
                };
            },
            async save() {
                // try {
                    store.commit('collections/SET_ENTITY', this.collection);
                    const { id } = await store.dispatch('collections/save');
                    for (const site of this.collection.sites) {
                        if(site.collection_site_id && site.site_id !== this.collection.site_id) {
                            await store.dispatch('collectionSites/delete', { collection_id: id, id: site.collection_site_id });
                        }
                    }
                    for (const site of this.collection.removedSites) {
                        if(site.collection_site_id) {
                            await store.dispatch('collectionSites/delete', { collection_id: id, id: site.collection_site_id });
                        }
                    }
                    console.log(this.collection.addedSites)
                    for (const index in this.collection.addedSites) {
                        const site = this.collection.addedSites[index];
                        store.commit('collectionSites/SET_ENTITY', {
                            id: site.collection_site_id,
                            collection_id: id,
                            site_id: site.id,
                            position: +index
                        });
                        await store.dispatch('collectionSites/save', { collection_id: id });
                    }
                    this.$router.push(`/collections/${ id }/detail`);
                // } catch (error) {
                //     alert('Ошибка сохранения');
                // }
            },
            async remove() {
                const { id } = this.$route.params;
                try {
                    await store.dispatch('collections/delete', { id });
                    this.$router.push('/collections');
                } catch (error) {
                    alert('Ошибка удаления');
                }
            },
            goBack() {
                const { id } = this.$route.params;
                if(id) {
                    this.$router.push(`/collections/${ id }/detail`);
                } else {
                    this.$router.push('/collections');
                }
            },
        },
    };
</script>